import './SupportPersonVolume.scss';
import { ReactElement, useState } from 'react';
import {
    REMOTE_CONTROL_EXCLUDE_CLASS,
    VOICE_VOLUME_DEFAULT,
    VOICE_VOLUME_MAX,
    type IVoiceVolume,
} from '@srm/screen-sharing/light';
import VoiceVolumeMenu from '@srm/ui/voice-volume-menu';
import { withPersonCard } from './withPersonCard';

export interface ISupportPersonVolumeProps {
    name: string;
    /** Пользователь-сотрудник: по наведению — его карточка, по нажатию — громкость */
    userKey?: string;
    volume: IVoiceVolume;
    onVolumeChange: (change: Partial<IVoiceVolume>) => void;
    /** Кружок сотрудника */
    children: ReactElement;
}

/**
 * Громкость сотрудника у пользователя (IMPLEMENTATION.md §42), как в Discord: нажатие на кружок — ползунок 0–200 % и
 * «Заглушить у меня»; наведение по-прежнему открывает карточку сотрудника, пока меню закрыто. Выбор запоминается по
 * пользователю сотрудника. Меню — в хосте порталов полосы (слой оверлеев, вне захвата) и вне глушения ввода.
 */
const SupportPersonVolume = ({ name, userKey, volume, onVolumeChange, children }: ISupportPersonVolumeProps) => {
    const [opened, setOpened] = useState(false);
    const menu = (
        <VoiceVolumeMenu
            name={name}
            volume={volume}
            onVolumeChange={onVolumeChange}
            opened={opened}
            onOpenChange={setOpened}
            targetClassName="support-bar__person-button"
            className={REMOTE_CONTROL_EXCLUDE_CLASS}
            muteDescription="Сотруднику об этом не сообщается"
            max={VOICE_VOLUME_MAX}
            normal={VOICE_VOLUME_DEFAULT}
            data-testid="support-bar-person-volume"
        >
            {children}
        </VoiceVolumeMenu>
    );
    return withPersonCard(userKey, name, menu, opened);
};

export default SupportPersonVolume;
